import { NotificationService } from '@capsicum/common';
import { Snackbar } from '@capsicum/common-web';
import { useRef } from 'react';

export const useReviewPledgeTransactionSnackbarSuccess = ({
	description,
	title
}: {
	description: string;
	title: string;
}) => {
	const hasSnackbarShown = useRef(false);

	const showReviewPledgeTransactionSnackbarSuccess = () => {
		if (hasSnackbarShown.current) return;

		hasSnackbarShown.current = true;
		NotificationService.addNotification({
			component: (
				<Snackbar
					description={description}
					testID="reviewPledgeTransaction-success-snackbar"
					title={title}
					variant="success"
				/>
			),
			persisted: true
		});
	};

	return {
		showReviewPledgeTransactionSnackbarSuccess
	};
};
